export default __webpack_public_path__ + "101e328ef2d78b87ba0a0eb53f9057a4.svg";